import { Controller } from "@hotwired/stimulus"

// Collapses the left navigation to an icon-only rail and back. The choice
// persists in localStorage so it survives navigation and reloads. Applies
// only at the sm+ breakpoint; the mobile top-bar layout is untouched.
export default class extends Controller {
  static targets = ["toggleIcon"]
  static classes = ["collapsed"]
  static values = { storageKey: { type: String, default: "pri2m-sidebar-collapsed" } }

  connect() {
    if (this.readStored()) this.apply(true)
  }

  toggle() {
    this.apply(!this.isCollapsed)
    this.writeStored(this.isCollapsed)
  }

  // When collapsed, the brand logo IS the expand button — swallow the
  // navigation and open the rail instead. When expanded, let the link
  // behave normally (navigate home).
  brandClick(event) {
    if (!this.isCollapsed) return

    event.preventDefault()
    this.apply(false)
    this.writeStored(false)
  }

  apply(collapsed) {
    this.isCollapsed = collapsed
    const cls = this.hasCollapsedClass ? this.collapsedClass : "sidebar-collapsed"
    this.element.classList.toggle(cls, collapsed)
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.toggle("bi-chevron-double-left", !collapsed)
      this.toggleIconTarget.classList.toggle("bi-chevron-double-right", collapsed)
    }
    this.element.setAttribute("aria-expanded", `${!collapsed}`)
  }

  readStored() {
    try {
      return window.localStorage.getItem(this.storageKeyValue) === "1"
    } catch (_error) {
      return false
    }
  }

  writeStored(collapsed) {
    try {
      window.localStorage.setItem(this.storageKeyValue, collapsed ? "1" : "0")
    } catch (_error) {
      // Storage may be unavailable (private mode); ignore.
    }
  }
}
